import React, { useEffect, useState } from 'react';
import 'react-tabs/style/react-tabs.css'; 
import Typography from '@mui/material/Typography'; 
  
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; 

const StakeInfo = ({  stakeData, weeklyYield, HtmlTooltip}) => {

    return (
        <div className="main details center" style={{ marginTop: 15, maxWidth: 1000 }}>
            <ul className="status">
                <li className="top">
                    <p className="desc">Est. APY
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Estimated Annual Percentage Yield (APY) &nbsp;</Typography>
                                    <span>Represents the projected annualized return on your staked amount, including compound rewards. Actual returns may vary based on staking duration and conditions.</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="text" style={{color: "#119f24"}}>{stakeData ? `${stakeData.apy}%` : "..."}</p>
                </li>
                <li className="top">
                    <p className="desc">Est. Weekly Yield
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Estimated Weekly Yield &nbsp;</Typography>
                                    <span>Represents the projected return you can earn in one week based on your staked amount and the current APY.&nbsp;</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="text" style={{color: "#119f24"}}>{weeklyYield} OSCAR</p>
                </li>

                <li className="top">
                    <p className="desc">Reward token
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Reward token (OSCAR)</Typography>
                                    <span>The token distributed as rewards for staking. This is the same token you stake to grow your holdings.</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="desc">OSCAR</p>
                </li>
                <li className="top">
                    <p className="desc">Total Staked with OSCAR</p>
                    <p className="desc">{stakeData ? `${stakeData.totalStakedAmount}` : '.....'}</p>
                </li>
                <li className="top">
                    <p className="desc">Total stakers</p>
                    <p className="desc">{stakeData ? `${stakeData.totalStakers}` : '.....'}</p>
                </li>
                <li className="top">
                    <p className="desc">Min Stake
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Minimum Stake Amount</Typography>
                                    <span>The minimum amount of OSCAR tokens required to participate in staking and earn rewards</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="desc">{stakeData ? `${stakeData.minStakeAmount} OSCAR` : '.....'}</p>
                </li>
                <li className="top">
                    <p className="desc"> Lock Period
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Lock Period</Typography>
                                    <span>The minimum duration your staked tokens must remain in the pool before they can be unstaked. Rewards can still be claimed during this time.&nbsp;</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="desc">{stakeData ? `${stakeData.lockPeriod} Days` : '.....'}</p>
                </li>
                <li className="top">
                    <p className="desc">Stake Fee
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">Stake Fee</Typography>
                                    <span>A small entry fee required for staking, ensuring secure participation and sustainable platform operations&nbsp;</span> <br />
                                </React.Fragment>
                            }
                        >
                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10, marginLeft: 4 }} />
                        </HtmlTooltip>
                    </p>
                    <p className="desc">{stakeData ? `${stakeData.stakeFee} ETH` : '.....'}</p>
                </li>
            </ul>


        </div>
    )
}
export default StakeInfo;